var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataSource.series[0].data.length)?_c('div',[_c('MixedCarts',{attrs:{"dataSource":_vm.dataSource}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }